// ======================================================
// FILE: src/services/weighbridge_service.js
// ======================================================
//
// PURPOSE:
// This service handles all frontend API calls related to
// the Wayware → UAG Weighbridge integration.
//
// IMPORTANT:
// - We DO NOT modify api_helper.js
// - We use makeEmployeeDashboardApiRequest
// - That helper already prefixes: /api/emp_dash_users/
//
// So if we pass: "weighbridge/tickets"
// The final URL becomes:
// /api/emp_dash_users/weighbridge/tickets
//
// ======================================================

import { makeEmployeeDashboardApiRequest } from "../api/api_helper";

/*
|--------------------------------------------------------------------------
| BASE ENDPOINT
|--------------------------------------------------------------------------
|
| All weighbridge routes start with:
|   weighbridge/tickets
|
| The helper automatically adds:
|   /api/emp_dash_users/
|
| So the full URL becomes:
|   /api/emp_dash_users/weighbridge/tickets
|
*/
const BASE_ENDPOINT = "weighbridge/tickets";

/*
|--------------------------------------------------------------------------
| WEIGHBRIDGE SERVICE OBJECT
|--------------------------------------------------------------------------
|
| This object exposes all frontend methods needed
| for interacting with weighbridge endpoints.
|
*/
export const WeighbridgeService = {

  /*
  |--------------------------------------------------------------------------
  | GET: List Unused Weighbridge Tickets
  |--------------------------------------------------------------------------
  |
  | Endpoint:
  |   GET /api/emp_dash_users/weighbridge/tickets
  |
  | Optional Query Params:
  |   - page
  |   - page_size
  |   - from_date
  |   - to_date
  |   - search (if backend supports)
  |
  | Example usage:
  |   WeighbridgeService.getTickets({ page: 1, page_size: 10 })
  |
  */
  getTickets: (params = {}) => {
    return makeEmployeeDashboardApiRequest(
      "get",
      BASE_ENDPOINT,
      params
    );
  },

  /*
  |--------------------------------------------------------------------------
  | GET: Single Ticket Details
  |--------------------------------------------------------------------------
  |
  | Endpoint:
  |   GET /api/emp_dash_users/weighbridge/tickets/:id
  |
  | Example usage:
  |   WeighbridgeService.getTicket(12)
  |
  */
  getTicket: (id) => {
    return makeEmployeeDashboardApiRequest(
      "get",
      `${BASE_ENDPOINT}/${id}`
    );
  },

  /*
  |--------------------------------------------------------------------------
  | POST: Create GRN From Ticket
  |--------------------------------------------------------------------------
  |
  | Endpoint:
  |   POST /api/emp_dash_users/weighbridge/tickets/:id/create-grn
  |
  | This tells backend to:
  |   - Create a GRN
  |   - Auto-fill supplier, commodity, quantity
  |   - Mark ticket as used
  |
  | Example usage:
  |   WeighbridgeService.createGrnFromTicket(12)
  |
  */
  createGrnFromTicket: (ticketId) => {
    return makeEmployeeDashboardApiRequest(
      "post",
      `${BASE_ENDPOINT}/${ticketId}/create-grn`,
      {}
    );
  },

};